// Metronic modal uses `$modal-zindex: 799999999` — portaled react-select menus must sit above it.
const MENU_PORTAL_Z_INDEX = 800000000;

export const customStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "var(--aug-surface-raised, #FFFFFF)",
    border: "1px solid var(--aug-ui-divider-subtle, #eff0f6)",
    borderRadius: "4px",
    overflow: "hidden",
    boxShadow: "0 4px 8px 0 rgba(52, 58, 64, 0.15)",
    zIndex: 20,
  }),
  menuPortal: (base) => ({ ...base, zIndex: MENU_PORTAL_Z_INDEX }),
  option: (base, state) => ({
    ...base,
    color: !state?.isDisabled ? "var(--bs-body-color, #333536)" : "var(--bs-secondary-color, #969696)",
    backgroundColor: "var(--aug-surface-raised, #FFFFFF)",
    ":active": {
      color: "var(--bs-body-color, #333536)",
      backgroundColor: "var(--bs-tertiary-bg, #F6F7FD)",
    },
    ":hover": {
      color: !state?.isDisabled ? "var(--bs-primary, #3399FF)" : "var(--bs-secondary-color, #969696)",
      backgroundColor: "var(--bs-tertiary-bg, #F6F7FD)",
    },
    padding: "0.5rem 1rem",
    fontWeight: 500,
    lineHeight: 1.2,
    textOverflow: "ellipsis",
    cursor: "pointer",
    fontSize: "13px",
  }),
  control: (provided) => ({
    ...provided,
    boxShadow: "0 0 0 0 transparent",
    borderColor: "var(--aug-ui-divider-subtle, #eff0f6)",
    backgroundColor: "var(--aug-surface-raised, #FFFFFF)",
    color: "var(--bs-body-color, #333536)",
    "&:hover": { borderColor: "var(--aug-ui-divider-subtle, #eff0f6)" },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "var(--bs-secondary-color, #969696)",
    fontWeight: 600,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "var(--bs-body-color, #333536)",
  }),
  // Critical: react-select always renders an input for focus/blur + typeahead.
  // It must remain in the DOM; we just ensure it doesn't show a "light" background in dark mode.
  input: (provided) => ({
    ...provided,
    color: "var(--bs-body-color, #333536)",
    backgroundColor: "transparent",
    caretColor: "var(--bs-body-color, #333536)",
    margin: 0,
    padding: 0,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "var(--bs-primary, #3399ff)",
  }),
  valueContainer: (provided) => ({
    ...provided,
    color: "var(--bs-body-color, #333536)",
    fontSize: "13px",
    backgroundColor: "transparent",
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "20px",
    background: "var(--bs-tertiary-bg, #eff0f6)",
  }),
  indicatorsContainer: (provided, state) =>
    state.isMulti
      ? {
          ...provided,
          display: "none",
        }
      : { ...provided },
  dropdownIndicator: (base, state) => ({
    ...base,
    width: 30,
    color: state.isFocused ? "var(--bs-body-color, #333536)" : "var(--bs-secondary-color, #CCCCCC)",
  }),
  clearIndicator: (base) => ({
    ...base,
    width: 35,
  }),
  menuList: (provided) => ({
    ...provided,
    overflowY: "auto",
    backgroundColor: "var(--aug-surface-raised, #FFFFFF)",
    paddingTop: 0,
    paddingBottom: 0,
  }),
};
